module.exports = __webpack_public_path__ + "static/media/flow-sms-pl.822311fc.png";